/**
 * 系统管理模块
 * 中文语言包
 */
export default {
  System: {
    Workflow: "工作流",
    WorkflowDefine: {
      WorkflowDefine: '工作流定义',
      Code: '编码',
      Name: '名称',
      Module: '模块',
      Version: '版本',
      State: '状态',
      Description: '描述',
      PublishStatus: '状态',
      PublishStatusOptions: {
        Published: '已发布',
        Unpublished: '未发布',
      },
      PublishTime: '发布时间',
      PublisherNickname: '发布人',
    }
  }
}